module.exports = __webpack_public_path__ + "rootimages/portfolio/large/06.jpg";